import request from '@/router/axios';

export const getList = (params) => {
    return request({
        url: '/api/produce/device-alarm-records/select/page',
        method: 'post',
        params
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/device-alarm-records/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/device-alarm-records/export/excel',
        method: 'post',
        params,
        responseType: 'blob'
    })
}
export const add = (row) => {
    return request({
        url: '/api/produce/base-device-manage/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/base-device-manage/update',
        method: 'post',
        data: row
    })
}


// 删除设备
export const remove = (id) => {
    return request({
        url: "/api/produce/base-device-manage/delete/id",
        method: "get",
        params: {
            id
        }
    });
};

// 报警处理
export const alarmHandling = (data) => {
  return request({
    url: '/api/produce/device-alarm-records/alarmHandling',
    method: 'post',
    data
  })
}

export const batchAlarmHandling = (ids, data) => {
  return request({
    url: '/api/produce/device-alarm-records/batchAlarmHandling',
    method: 'post',
    params: { ids },
    data
  })
}

export const oneClickAlarmHandling = (data) => {
  return request({
    url: '/api/produce/device-alarm-records/oneClickAlarmHandling',
    method: 'post',
    data
  })
}
